module.exports = __webpack_public_path__ + "img/potterbot.260c769e.jpg";